import React, { FC } from 'react';
import styled from 'styled-components';
import { COMPUTER } from 'assets/images/images';
import { Button } from 'antd';
import { Text } from 'components/text/Text';
import { translate, translationKeys } from 'logic/translations/translations.service';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

const CenterContentWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

const GoHomeButton = styled(Button)`
  margin-bottom: 4rem;
  width: 80%;
`;

export const OpenInDesktop: FC = () => {
  return (
    <Wrapper>
      <CenterContentWrapper>
        <img src={COMPUTER} alt={'computer'} style={{ marginBottom: '1rem' }} loading="lazy" />
        <Text size={28} style={{ marginBottom: '1rem' }}>
          {translate(translationKeys.tutoringInstituteProfile.onMobile.text1)}
        </Text>
        <Text size={22} fontWeight={500}>
          {translate(translationKeys.tutoringInstituteProfile.onMobile.text2)}
        </Text>
      </CenterContentWrapper>
      <GoHomeButton type={'primary'} href={'/'}>
        {translate(translationKeys.tutoringInstituteProfile.onMobile.backToHomepage)}
      </GoHomeButton>
    </Wrapper>
  );
};
